interface TickableNextStep {
  memberId?: string | null
  circleId: string
}

// The one thing asked of OrgData: who takes part in a circle.
interface CircleParticipantsSource {
  getParticipants(circleId: string): readonly { member: { id: string } }[]
}

// Only the assignee ticks a step from the list (D15) — a UI lock, not a Hasura
// one: the server allows the whole circle, which D12 requires for the meeting.
// A step nobody carries (its meeting was deleted) falls back to the circle,
// the same participants Hasura checks (#205) — otherwise nobody could tick it.
export default function canTickNextStep(
  nextStep: TickableNextStep,
  currentMemberId: string | undefined,
  orgData: CircleParticipantsSource | undefined
): boolean {
  if (!currentMemberId) return false
  if (nextStep.memberId) return nextStep.memberId === currentMemberId
  return !!orgData
    ?.getParticipants(nextStep.circleId)
    .some((participant) => participant.member.id === currentMemberId)
}
